import React, { useState } from 'react';

const DEFAULT_PROPS = {
  confirmText: '',
  confirmFnc: null,
  cancleFnc: null,
};
const useConfirmationDialog = () => {
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [confirmationDialogProps, setConfirationDialogProps] = useState(DEFAULT_PROPS);

  const handleOpenConfirmationDialog = (cofirmTxt, confirmFnc, rejectFnc) => {
    setConfirationDialogProps({
      confirmText: cofirmTxt,
      confirmFnc: confirmFnc,
      cancleFnc: rejectFnc,
    });
    setOpenConfirmationDialog(true);
  };
  const closeConfirmationDialog = () => {
    setOpenConfirmationDialog(false);
    setConfirationDialogProps(DEFAULT_PROPS);
  };
  return {
    openConfirmationDialog,
    setOpenConfirmationDialog,
    handleOpenConfirmationDialog,
    confirmationDialogProps,
    closeConfirmationDialog,
  };
};

export default useConfirmationDialog;
